// extracted by mini-css-extract-plugin
export var boxItems = "_85-1";
export var button = "_85-5";
export var filterGroupBox = "_85-0";
export var icon = "_85-2";
export var iconSecondary = "_85-4";
export var iconWrapper = "_85-3";